// EmptyStateMessage.jsx
import * as React from 'react';
import { Box, Paper, Typography, Fade } from '@mui/material';
import QueryStatsOutlinedIcon from '@mui/icons-material/QueryStatsOutlined';

export default function EmptyStateMessage({
  message = '',
  minHeight = 10,
  maxHeight = 100,
  iconSize = 26,
  width = 25,
}) {
  return (
    <Fade in timeout={250}>
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          textAlign: 'center',
          bgcolor: theme => (theme.palette.mode === 'dark' ? 'background.default' : '#fff'),
          border: theme => `1px solid ${theme.palette.divider}`,
          boxShadow: '0 1px 2px rgba(16,24,40,0.04), 0 4px 12px rgba(16,24,40,0.06)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight,
          maxHeight,
        }}>
        <Box>
          {/* Top icon */}
          <Box
            sx={{
              width: 20,
              height: 20,
              mx: 'auto',
              mb: 1.5,
              borderRadius: '50%',
              display: 'grid',
              placeItems: 'center',
              bgcolor: theme => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(146, 146, 146, 0.2)'),
            }}>
            <QueryStatsOutlinedIcon
              sx={{
                fontSize: iconSize,
                color: theme => (theme.palette.mode === 'dark' ? theme.palette.grey[300] : theme.palette.grey[700]),
              }}
            />
          </Box>

          {/* message / helper text */}
          <Typography
            variant="body2"
            sx={{
              color: theme => (theme.palette.mode === 'dark' ? theme.palette.grey[400] : theme.palette.grey[600]),
              mx: 'auto',
              lineHeight: 1.6,
              fontWeight: '400',
              fontSize: '1.1rem',
            }}>
            {message}
          </Typography>
        </Box>
      </Paper>
    </Fade>
  );
}
